"use client";

import { c as _c } from "react/compiler-runtime";
import { parseAsBoolean, useQueryState } from "nuqs";
import { useFilterDefaults } from "@/components/layout/FilterDefaultsProvider";
import { QUERY_PARAM_KEYS } from "./keys";
export function useIsVerifiedQueryParam() {
  const $ = _c(9);
  const {
    isVerified: defaultIsVerified
  } = useFilterDefaults();
  let t0;
  if ($[0] !== defaultIsVerified) {
    t0 = parseAsBoolean.withDefault(Boolean(defaultIsVerified));
    $[0] = defaultIsVerified;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const [isVerified, setIsVerified] = useQueryState(QUERY_PARAM_KEYS.isVerified, t0);
  let t1;
  if ($[2] !== defaultIsVerified || $[3] !== isVerified || $[4] !== setIsVerified) {
    t1 = async function toggleIsVerified() {
      const defaultValue = Boolean(defaultIsVerified);
      const effective = isVerified ?? defaultValue;
      if (defaultValue) {
        await setIsVerified(effective ? false : null);
      } else {
        await setIsVerified(effective ? null : true);
      }
    };
    $[2] = defaultIsVerified;
    $[3] = isVerified;
    $[4] = setIsVerified;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const toggleIsVerified = t1;
  let t2;
  if ($[6] !== isVerified || $[7] !== toggleIsVerified) {
    t2 = {
      isVerified,
      toggleIsVerified
    };
    $[6] = isVerified;
    $[7] = toggleIsVerified;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}